import { createSlice } from "@reduxjs/toolkit";
import { GLOBAL_FILTERS } from "../constants";

const initialState = {
  showFilterModal: false,
  fromDate: "",
  toDate: "",
  clientId: "",
  resellerId: "",
  txnStatus: "",
  serviceType: "",
  resellerStatus: "",
  serviceProvider: "",
  filters: [],
  clearDashboardFilter: false,
  custRefNo: "",
  transactionId: "",
  van: "",
  bankUTR: "",
  email:"",
  mobileNumber:"",
  upi:""
};

export const globalFiltersSlice = createSlice({
  name: GLOBAL_FILTERS,
  initialState,
  reducers: {
    showHideFilterModalReducer: (state, action) => {
      const data = {
        ...state,
        showFilterModal: action.payload.showFilterModal,
        filters: action.payload.filters,
      };
      return (state = data);
    },
    globalFilterReducer: (state, action) => {
      const data = {
        ...state,
        ...action.payload,
      };
      return (state = data);
    },
    clearGlobalFilterReducer: () => initialState,
    clearDashboardFilterSlice: (state, action) => {
      const data = {
        ...state,
        clearDashboardFilter: !state?.clearDashboardFilter,
      };

      return (state = data);
    },
  },
});

export const {
  globalFilterReducer,
  clearGlobalFilterReducer,
  showHideFilterModalReducer,
  clearDashboardFilterSlice,
} = globalFiltersSlice.actions;

export default globalFiltersSlice.reducer;
